export default Object.freeze({
  tab: 'info',
  tabsList: [],
  disabledTabs: false,
  isPreSubmitFlag: false,
});
